<template>
    <layout>
        <div>
            <!-- Info -->
            <div class="mb-2">
                <info-collapse-area>
                    <template v-slot:title>
                        <div class="w-100 d-flex flex-column flex-md-row justify-content-md-between">
                            <div class="mt-1 mt-md-0 mb-1 mb-md-0 fs-16">
                                {{ getObjectValue(application, 'name') }} {{ getObjectValue(application, 'surname') }}
                            </div>
                            <!--
                            <div class="mb-1 mb-md-0 mr-0 mr-md-4">
                                <template v-if="application.result">
                                    <b-badge
                                        :variant="(application.result == 'placed' ? 'success' : 'danger') + ' text-uppercase'">
                                        {{ resultStatusText }}
                                    </b-badge>
                                </template>
                                <template v-else>
                                    {{ applicationStatusMessage }}
                                </template>
                            </div>
                            -->
                        </div>
                    </template>
                    <template v-slot:detail>
                        {{ getObjectValue(application, 'name') }}
                        {{ getObjectValue(application, 'surname') }} - {{ applicationStatusMessage }}
                    </template>
                </info-collapse-area>
            </div>
            <div class="border rounded-sm pt-4 pl-4 pr-4">
                <b-tabs content-class="py-5 position-relative" class="line-tabs" fill>
                    <div class="tabs-bottom-line"></div>
                    <b-tab :active="tabIndex == -1">
                        <template #title>
                            {{ $t('general_information') }}
                        </template>
                        <template>
                            <div v-html="generalTabInfo"></div>
                            <b-row>
                                <b-col cols="12">
                                    <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                                </b-col>
                            </b-row>
                            <div class="d-flex justify-content-center mt-3">
                                <processing-button :processing="formLoading" variant="primary"
                                                   :label="$t('forward').toUpper()" @click="goTab(0)" />
                            </div>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 0" :disabled="tabIndex > -1 ? false : true">
                        <template #title>
                            {{ $t('personal_info') }}
                        </template>
                        <template>
                            <ValidationObserver ref="personalInfoFormValidate">
                                <h6>{{ $t('identity_information') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('national_id')">
                                                    <ValidationProvider name="national_id" rules="required" v-slot="{ errors }">
                                                        <b-form-input v-model="formData.national_id"
                                                                      :state="errors[0] ? false : null" :disabled="true" />
                                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                    </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('name')">
                                                <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.name"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('surname')">
                                                <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.surname"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('birthdate')">
                                                    <select-date v-model="formData.birthdate" :validationError="errors[0]" :disabled="true" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('birthplace')">
                                                <ValidationProvider name="birthplace" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.birthplace"
                                                                  v-mask="letterAndSpaceMask"

                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="gender" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('gender')">
                                                    <gender-selectbox v-model="formData.gender"
                                                                      :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="nationality_code" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('nationality')">
                                                    <nationality-selectbox v-model="formData.nationality_code"
                                                                      :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('father_name')">
                                                <ValidationProvider name="father_name" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.father_name"
                                                                  :state="errors[0] ? false : null"
                                                                  />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('mother_name')">
                                                <ValidationProvider name="mother_name" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.mother_name"
                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>

                                <h6>{{ $t('contact_information') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('email')">
                                                <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.email"
                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('gsm_no')">
                                                <ValidationProvider name="mobile_tel" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.mobile_tel"
                                                                  v-mask="'### ### ## ##'"
                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('alternative_tel')">
                                                <ValidationProvider name="alternative_mobile_tel" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.alternative_mobile_tel"
                                                                  v-mask="'### ### ## ##'"
                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>

                                <b-row>
                                    <b-col cols="12" md="6">
                                        <h6>{{ $t('residence_address') }}</h6>
                                        <div class="border p-4 rounded-sm mb-3">
                                            <b-row>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="city" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('city')">
                                                            <city-selectbox v-model="formData.city"
                                                                              :validateError="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="district" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('district')">
                                                            <district-outline-selectbox v-model="formData.district"
                                                                            :city_id="formData.city"
                                                                            :validateError="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="12" lg="12">
                                                    <ValidationProvider name="address" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('address')">
                                                            <b-form-textarea v-model="formData.address" rows="3"
                                                                             :state="errors[0] ? false : null" />
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <b-form-group :label="$t('postal_code')">
                                                        <ValidationProvider name="postal_code" rules="" v-slot="{ errors }">
                                                            <b-form-input v-model="formData.postal_code"
                                                                          :state="errors[0] ? false : null" />
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                        </ValidationProvider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <h6>{{ $t('communication_address') }}</h6>
                                        <div class="border p-4 rounded-sm mb-3">
                                            <b-row>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="contact_city" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('city')">
                                                            <city-selectbox v-model="formData.contact_city"
                                                                            :validateError="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="contact_district" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('district')">
                                                            <district-outline-selectbox v-model="formData.contact_district"
                                                                                        :city_id="formData.contact_city"
                                                                                        :validateError="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="12" lg="12">
                                                    <ValidationProvider name="contact_address" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('address')">
                                                            <b-form-textarea v-model="formData.contact_address" rows="3"
                                                                             :state="errors[0] ? false : null" />
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <b-form-group :label="$t('postal_code')">
                                                        <ValidationProvider name="contact_postal_code" rules="" v-slot="{ errors }">
                                                            <b-form-input v-model="formData.contact_postal_code"
                                                                          :state="errors[0] ? false : null" />
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                        </ValidationProvider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </b-col>
                                </b-row>
                                <h6>{{ $t('health_information') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="disability" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('disability_status')">
                                                    <multi-selectbox v-model="formData.disability"
                                                                     :options="disabilityOptions"
                                                                     :multiple="false"
                                                                     :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="8" class="mt-5" v-if="formData.disability != 'H'">
                                            <ValidationProvider name="disability_file" v-slot="{errors}">
                                                <b-input-group class="mb-0 mt-1">
                                                    <b-form-file v-model="formData.disability_file"
                                                                 :placeholder="$t('report_upload')"
                                                                 :state="errors[0] ? false : null"
                                                                 ref="fileInput"
                                                    />
                                                    <b-input-group-append>
                                                        <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                <div class="alert alert-info mt-2">{{$t('report_upload_info')}}</div>
                                                <b-button variant="outline-primary" class="mb-4" v-if="formData.disability_document" @click="downloadAppFile('disability_file')">
                                                    <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('file_download')}}
                                                </b-button>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" v-if="formData.disability != 'H'">
                                            <b-alert variant="warning" show v-html="$t('conservatory_app_disability_info')" />
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col cols="12">
                                        <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                                    </b-col>
                                </b-row>
                                <div class="d-flex justify-content-center mt-3">
                                    <processing-button :processing="formLoading" variant="primary"
                                                       :label="$t('save_and_go').toUpper()" @click="save" />
                                </div>
                            </ValidationObserver>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 1" :disabled="tabIndex > 0 ? false : true">
                        <template #title>
                            {{ $t('education_info') }}
                        </template>
                        <template>
                            <ValidationObserver ref="educationInfoFormValidate">
                                <h6>{{ $t('high_school_info') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('graduate_high_school_name')">
                                                <ValidationProvider name="school_name" rules="required" v-slot="{ errors }">
                                                    <highschool-auto-complete-conservatory
                                                        v-model="formData.school_name"
                                                        :national-id="formData.national_id"
                                                        :pin="pin"
                                                        @selectedObject="selectedSchool"
                                                        :validateError="errors[0]" />
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('high_school_diploma_score')">
                                                <ValidationProvider name="school_diploma_point" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.school_diploma_point"
                                                                  type="number"
                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="school_major_type" rules="" v-slot="{ errors }">
                                                <b-form-group :label="$t('high_school_major_type')">
                                                    <multi-selectbox v-model="formData.school_major_type"
                                                                     :options="schoolMajorTypeOptions"
                                                                     :multiple="false"
                                                                     :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('graduate_high_school_code')">
                                                <ValidationProvider name="school_code" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.school_code"
                                                                  :disabled="true"
                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="school_graduate_date" rules="" v-slot="{ errors }">
                                                <b-form-group :label="$t('high_school_graduate_date')">
                                                    <select-date v-model="formData.school_graduate_date" :validationError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                </div>
                                <h6>{{ $t('exam_info') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('tyt_year')">
                                                <ValidationProvider name="exam_year" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.exam_year"
                                                                  type="number"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('tyt_score')">
                                                <ValidationProvider name="exam_point" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.tyt_point"
                                                                  type="number"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                    <b-form-text id="input-live-help">{{ $t('tyt_info') }}</b-form-text>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                                <h6>{{ $t('university_informations') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('accepted_university_in', { year: 2025 })">
                                                <ValidationProvider name="has_university_enrollment" rules="required" v-slot="{ errors }">
                                                    <multi-selectbox v-model="formData.has_university_enrollment"
                                                                     :options="yesNoOptions"
                                                                     :multiple="false"
                                                                     :validateError="errors[0]" />
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="formData.has_university_enrollment == 'E'">
                                        <b-col cols="12" md="6" lg="6">
                                            <ValidationProvider name="document_barcode_no" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('document_barcode_no')">
                                                    <b-form-input v-model="formData.university_barcode_no"
                                                                  :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                    <b-form-text id="input-live-help">{{ $t('document_barcode_no_info') }}</b-form-text>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row v-else-if="formData.has_university_enrollment == 'H'">
                                        <b-col cols="12">
                                            <b-form-group>
                                                <div @click="openStatement1Modal">
                                                    <b-form-checkbox v-model="statement1"
                                                                     :state="statement1Validate ? false : null"
                                                                     :disabled="!statement1">
                                                    <span v-html="$t('statement_1')"
                                                          @click="openStatement1Modal"></span>
                                                    </b-form-checkbox>
                                                </div>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col cols="12">
                                        <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                                    </b-col>
                                </b-row>
                                <div class="d-flex justify-content-center mt-3">
                                    <processing-button :processing="formLoading" variant="primary"
                                                       :label="$t('save_and_go').toUpper()" @click="saveEducationInfo" />
                                </div>
                            </ValidationObserver>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 2" :disabled="tabIndex > 1 ? false : true">
                        <template #title>
                            {{ $t('application_information') }}
                        </template>
                        <template>
                            <ValidationObserver ref="applicationInfoFormValidate">
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-alert variant="warning" show><i class="ri-focus-2-line"></i> <u>{{$t('conservatory_app_warning')}}</u></b-alert>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-badge variant="secondary" class="text-black-50 font-size-15">1. {{ $t('preference') }}</b-badge>
                                            <hr class="mt-0" />
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <ValidationProvider name="program_code" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('program_select')">
                                                    <program-selectbox v-model="formData.program_code"
                                                                       :public="true"
                                                                       @input="deleteLoadedProgramDetail"
                                                                       :major_type="'A'"
                                                                       :faculty_code="11"
                                                                     :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="program_detail"
                                                                v-if="['11022101','11042101'].includes(formData.program_code)"
                                                                :rules="['11022101','11042101'].includes(formData.program_code) ? 'required' : ''"
                                                                v-slot="{ errors }">
                                                    <b-form-group :label="$t('branch')">
                                                        <multi-selectbox v-model="formData.program_detail"
                                                                         :multiple="false"
                                                                         :options="branchOptions"
                                                                         :validateError="errors[0]" />
                                                    </b-form-group>
                                                </ValidationProvider>
                                            <ValidationProvider name="interview_type" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('interview_preference')">
                                                    <parameter-selectbox v-model="formData.interview_type"
                                                                         code="conservatory_application_interview_preference"
                                                                         :public="true"
                                                                       :multiple="false"
                                                                       :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="8">
                                            <b-alert variant="danger" show v-if="['11022101'].includes(formData.program_code)">{{ $t('letter_of_intent_info') }}</b-alert>
                                            <ValidationProvider name="letter_of_intent" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('letter_of_intent')">
                                                    <b-form-textarea v-model="formData.letter_of_intent" rows="7"
                                                                     placeholder="Bu alana kendinizi tanıtan, bölümü seçmedeki amaçlarınızı belirten ve şimdiye kadar yaptığınız çalışmaları içeren bir niyet mektubu yazınız."
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="file" rules="" v-slot="{errors}">
                                                <b-input-group class="mb-0">
                                                    <b-form-file v-model="formData.file"
                                                                 :placeholder="$t('upload_file')"
                                                                 :state="errors[0] ? false : null"
                                                                 ref="fileInputf"
                                                    />
                                                    <b-input-group-append>
                                                        <b-button variant="outline-secondary" @click="$refs.fileInputf.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                <div class="alert alert-info mt-2">{{$t('filesize_alert')}}</div>
                                                <b-button variant="outline-primary" v-if="formData.first_program_document" @click="downloadAppFile('first_application')">
                                                    <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('file_download')}}
                                                </b-button>
                                            </ValidationProvider>
                                            <ValidationProvider name="link_1" rules="" v-slot="{ errors }">
                                                <b-form-group label="Link 1">
                                                    <b-form-input v-model="formData.link_1"
                                                                  placeholder="Link 1"
                                                                  :state="errors[0] ? false : null" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-badge variant="secondary" class="text-black-50 font-size-15">2. {{ $t('preference') }}</b-badge>
                                            <hr class="mt-0" />
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <ValidationProvider name="second_program_code" rules="" v-slot="{ errors }">
                                                <b-form-group :label="$t('program_select')">
                                                    <program-selectbox v-model="formData.second_program_code"
                                                                       :public="true"
                                                                       :major_type="'A'"
                                                                       :faculty_code="11"
                                                                       @input="checkProgramCode"
                                                                       v-if="programDataInfo"
                                                                       :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="second_program_detail"
                                                                v-if="['11022101','11042101'].includes(formData.second_program_code)"
                                                                :rules="['11022101','11042101'].includes(formData.second_program_code) && formData.second_program_code ? 'required' : ''"
                                                                v-slot="{ errors }">
                                                <b-form-group :label="$t('branch')">
                                                    <multi-selectbox v-model="formData.second_program_detail"
                                                                     :multiple="false"
                                                                     :options="secondBranchOptions"
                                                                     :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="second_interview_type" :rules="formData.second_program_code ? 'required' : ''" v-slot="{ errors }">
                                                <b-form-group :label="$t('interview_preference')">
                                                    <parameter-selectbox v-model="formData.second_interview_type"
                                                                         code="conservatory_application_interview_preference"
                                                                         :public="true"
                                                                         :multiple="false"
                                                                         :validateError="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="8">
                                            <b-alert variant="danger" show v-if="['11022101'].includes(formData.second_program_code)">{{ $t('letter_of_intent_info') }}</b-alert>
                                            <ValidationProvider name="second_letter_of_intent" :rules="formData.second_program_code ? 'required' : ''" v-slot="{ errors }">
                                                <b-form-group :label="$t('letter_of_intent')">
                                                    <b-form-textarea v-model="formData.second_letter_of_intent" rows="7"
                                                                     placeholder="Bu alana kendinizi tanıtan, bölümü seçmedeki amaçlarınızı belirten ve şimdiye kadar yaptığınız çalışmaları içeren bir niyet mektubu yazınız."
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="second_file" rules="" v-slot="{errors}">
                                                <b-input-group class="mb-0">
                                                    <b-form-file v-model="formData.second_file"
                                                                 :placeholder="$t('upload_file')"
                                                                 :state="errors[0] ? false : null"
                                                                 ref="fileInput2"
                                                    />
                                                    <b-input-group-append>
                                                        <b-button variant="outline-secondary" @click="$refs.fileInput2.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                <div class="alert alert-info mt-2">{{$t('filesize_alert')}}</div>
                                                <b-button variant="outline-primary" v-if="formData.second_program_document" @click="downloadAppFile('second_application')">
                                                    <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('file_download')}}
                                                </b-button>
                                            </ValidationProvider>
                                            <ValidationProvider name="link_2" rules="" v-slot="{ errors }">
                                                <b-form-group label="Link 2">
                                                    <b-form-input v-model="formData.link_2"
                                                                  placeholder="Link 2"
                                                                  :state="errors[0] ? false : null" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" class="mt-4">
                                            <div @click="openApproveModal('App')">
                                                <ValidationProvider name="approveApp" rules="required" v-slot="{}">
                                                    <b-form-checkbox
                                                        :id="'checkbox-app'"
                                                        :name="'checkbox-app'"
                                                        :value="true"
                                                        :unchecked-value="false"
                                                        :state="approveAppValidate ? false : null"
                                                        @change="approveApp = false"
                                                        v-model="approveApp">
                                                        {{ $t('conservatory_app_approve') }}
                                                    </b-form-checkbox>
                                                    <b-form-invalid-feedback v-if="approveAppValidate">{{ $t('this_field_is_required') }}</b-form-invalid-feedback>
                                                </ValidationProvider>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" class="mt-4">
                                            <div @click="openApproveModal('Multi')">
                                                <ValidationProvider name="approveMultimedia" rules="required" v-slot="{}">
                                                    <b-form-checkbox
                                                        :id="'checkbox-multi'"
                                                        :name="'checkbox-multi'"
                                                        :value="true"
                                                        :state="approveMultimediaValidate ? false : null"
                                                        :unchecked-value="false"
                                                        @change="approveMultimedia = false"
                                                        v-model="approveMultimedia">
                                                        {{ $t('conservatory_app_approve_multimedia') }}
                                                    </b-form-checkbox>
                                                    <b-form-invalid-feedback v-if="approveMultimediaValidate">{{ $t('this_field_is_required') }}</b-form-invalid-feedback>
                                                </ValidationProvider>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" class="mt-4" v-if="formData.is_previous_application">
                                            <div>
                                                <ValidationProvider name="is_previous_application_confirmed" v-slot="{errors}">
                                                    <b-form-checkbox
                                                        :id="'checkbox-prev'"
                                                        :name="'checkbox-prev'"
                                                        :value="true"
                                                        :unchecked-value="false"
                                                        v-model="formData.is_previous_application_confirmed">
                                                        {{ $t('conservatory_app_prev_info') }}
                                                    </b-form-checkbox>
                                                    <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                                                </ValidationProvider>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col cols="12">
                                        <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                                    </b-col>
                                </b-row>
                                <div class="d-flex justify-content-center mt-3">
                                    <processing-button :processing="formLoading" variant="primary"
                                                       :label="$t('save_application').toUpper()" @click="saveApplicationInfo" />
                                </div>
                            </ValidationObserver>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 3" :disabled="tabIndex > 2 ? false : true">
                        <template #title>
                            {{ $t('paymennt_cartoon_animation') }}
                        </template>
                        <template>
                            <ValidationObserver ref="paymentFormValidate">
                                <h6>{{ $t('cartoon_animation_app_payment_info') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-alert variant="dark" show>
                                                <h3 class="mt-1" v-if="formData.exam_price == null">{{ $t('payment_total')+' : 0 TL' }}</h3>
                                                <h3 class="mt-1" v-else>{{ $t('payment_total')+' : '+formData.exam_price+' TL' }}</h3>
                                            </b-alert>
                                            <b-alert variant="success" show v-if="application.payment_status == 'E'">
                                                <span class="font-size-20 font-weight-bold">{{$t('payment_success')}}</span>
                                            </b-alert>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <div class="border p-4 rounded-sm mb-3">
                                                <b-row>
                                                    <b-col cols="12" md="12">
                                                        <b-form-group :label="$t('card_holder_name')">
                                                            <ValidationProvider name="card_holder_name" rules="required" v-slot="{ errors }">
                                                                <b-form-input v-model="paymentFormData.card_holder_name"
                                                                              class="font-weight-bold text-center"
                                                                              :state="errors[0] ? false : null" />
                                                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                            </ValidationProvider>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" md="12">
                                                        <b-form-group :label="$t('card_number')">
                                                            <ValidationProvider name="card_number" rules="required" v-slot="{ errors }">
                                                                <b-form-input v-model="paymentFormData.card_number"
                                                                              class="font-weight-bold text-center"
                                                                              v-mask="'#### #### #### ####'"
                                                                              :state="errors[0] ? false : null" />
                                                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                            </ValidationProvider>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" md="6">
                                                        <b-form-group :label="$t('expiry_month')">
                                                            <ValidationProvider name="expiry_month" rules="required" v-slot="{ errors }">
                                                                <multi-selectbox v-model="paymentFormData.expiry_month"
                                                                                 :options="expiryMonthOptions"
                                                                                 :multiple="false"
                                                                                 :validateError="errors[0]" />
                                                            </ValidationProvider>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" md="6">
                                                        <b-form-group :label="$t('expiry_year')">
                                                            <ValidationProvider name="expiry_year" rules="required" v-slot="{ errors }">
                                                                <years-selectbox v-model="paymentFormData.expiry_year"
                                                                                 :up="true"
                                                                                 :interval="10"
                                                                                 :validateError="errors[0]" />
                                                            </ValidationProvider>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" md="6">
                                                        <b-form-group label="CVV">
                                                            <ValidationProvider name="cvv" rules="required" v-slot="{ errors }">
                                                                <b-form-input v-model="paymentFormData.cvv"
                                                                              class="font-weight-bold text-center"
                                                                              v-mask="'###'"
                                                                              :state="errors[0] ? false : null" />
                                                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                            </ValidationProvider>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div class="d-flex justify-content-center mt-3" v-if="application.payment_status == 'H'">
                                    <processing-button :processing="formLoading" variant="primary"
                                                       :label="$t('make_payment').toUpper()" @click="makePayment" />
                                </div>
                            </ValidationObserver>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 4" :disabled="tabIndex > 3 ? false : true">
                        <template #title>
                            {{ $t('special_talent_exam') }}
                        </template>
                        <template>
                            <h6>{{ $t('exam_info') }}</h6>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-row>
                                    <b-col cols="12">
                                        <b-table :empty-filtered-text="$t('no_result')"
                                                 :empty-text="$t('no_result')"
                                                 bordered
                                                 responsive
                                                 :items="examListData"
                                                 :fields="examListFields"
                                                 show-empty
                                                 class="mb-4 table-dropdown no-scrollbar border rounded">
                                            <template #cell(rank)="row">
                                                {{row.item.rank+'.'+$t('preference')}}
                                            </template>
                                            <template #cell(program)="row">
                                                <span v-if="row.item.program_detail">
                                                    {{row.item.program+' ('+row.item.program_detail+')'}}
                                                </span>
                                                <span v-else>
                                                    {{row.item.program}}
                                                </span>
                                            </template>
                                        </b-table>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="12" class="mt-4">
                                        <b-alert variant="warning" show v-if="constantAddress != null">
                                            {{constantAddress}}
                                        </b-alert>
                                    </b-col>


                                    <b-col cols="12" class="mt-4">
                                        <b-alert variant="info" show v-if="application.exam_location == null">
                                            Sınav yeri ve tarihi daha sonra ilan edilecektir. Bu ekrandan kontrol edebilirsiniz.
                                        </b-alert>
                                        <b-alert variant="info" show v-if="application.status == 'waiting'">
                                            Başvurunuz değerlendirme aşamasındadır.
                                        </b-alert>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 5" :disabled="tabIndex > 3 ? false : true">
                        <template #title>
                            {{ $t('application_status') }}
                        </template>
                        <template>
                            <h6>{{ $t('estimate_status') }}</h6>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-alert variant="info" show v-if="formData.result_name && formData.result != 'waiting'">{{formData.result_name}}</b-alert>
                                <span v-else>-</span>
                            </div>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-row>
                                    <b-col cols="12">
                                        <b-table :empty-filtered-text="$t('no_result')"
                                                 :empty-text="noDataInfo"
                                                 bordered
                                                 responsive
                                                 :items="formData.messages"
                                                 :fields="estimateFields"
                                                 show-empty
                                                 class="mb-4 table-dropdown no-scrollbar border rounded" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
        <CommonModal ref="approveAppModal" size="md">
            <template v-slot:CommonModalContent>
                <div v-html="approveModalContent"></div>
                <div class="d-flex justify-content-center mt-4">
                    <b-button variant="primary" @click="approveAction">{{$t('i_approve')}}</b-button>
                </div>
            </template>
        </CommonModal>
        <CommonModal ref="progressModal" size="lg" :closeBtn="false" :onHideOnlyX="true">
            <template v-slot:CommonModalContent>
                <b-row>
                    <b-col cols="12">
                        <b-progress max="100" :value="progressValue" show-progress class="mb-3"></b-progress>
                    </b-col>
                    <b-col cols="12">
                        <b-alert show variant="info">{{$t('progress_bar_text',{min: progressTime})}}</b-alert>
                    </b-col>
                </b-row>
            </template>
        </CommonModal>
        <CommonModal ref="statementModal1">
            <template v-slot:CommonModalTitle>
                <div>{{ $t('statement_1') }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <p v-html="statementInfo" />
                <b-button variant="primary" type="button" @click="checkStatement1">{{$t('read_and_accept')}}</b-button>
            </template>
        </CommonModal>
        <CommonModal ref="paymentModal" size="lg" :closeBtn="false" :onHideOnlyX="true">
            <template v-slot:CommonModalContent>
                <b-row>
                    <b-col cols="12" v-if="paymentHtml">
                        <iframe style="width: 100%; border: none; height: 38rem;" sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts"
                                :srcdoc="paymentHtml" frameborder="1" id="payment-frame"></iframe>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-center mb-3" v-else>
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-center mb-3">
                        <b-button variant="primary" @click="close3dModal">{{ $t('close') }}</b-button>
                    </b-col>
                </b-row>
            </template>
        </CommonModal>
    </layout>
</template>

<script>
// Layouts
import Layout from '../layout/Layout'

// Component
import GenderSelectbox from '@/components/interactive-fields/GenderSelectbox'
import InfoCollapseArea from '@/components/elements/InfoCollapseArea'
import NationalitySelectbox from '@/components/interactive-fields/NationalitySelectbox'
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox'
import ProcessingButton from '@/components/elements/ProcessingButton'
import ProgramSelectbox from '@/components/interactive-fields/ProgramSelectbox'
import SelectDate from '@/components/interactive-fields/SelectDate'
import CitySelectbox from '@/components/interactive-fields/CitySelectbox'
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"
import MultiSelectbox from '@/components/interactive-fields/MultiSelectbox'
import YearsSelectbox from "@/components/interactive-fields/YearsSelectbox"
import HighschoolAutoCompleteConservatory from "@/components/interactive-fields/HighschoolAutoCompleteConservatory"

// Services
import ConservatoryService from "@/services/ConservatoryService"
import ConstantService from "@/services/ConstantService"

// Pages

// Other
import CommonModal from '@/components/elements/CommonModal';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import isset from 'isset-php'
import Branchs from "@/modules/conservatoryApplication/data/Branchs"
import qs from "qs";
import FashionDesignService from "@/services/FashionDesignService";


export default {
    name: "TransferPage",
    components: {
        HighschoolAutoCompleteConservatory,
        Layout,
        GenderSelectbox,
        InfoCollapseArea,
        NationalitySelectbox,
        ProcessingButton,
        ProgramSelectbox,
        SelectDate,
        CommonModal,
        CitySelectbox,
        DistrictOutlineSelectbox,
        MultiSelectbox,
        YearsSelectbox,
        ParameterSelectbox,
        ValidationObserver,
        ValidationProvider
    },
    metaInfo() {
        return {
            title: this.$t("conservatory")+' '+this.$t('application_system'),
        };
    },
    computed: {
        applicationStatus() {
            let data = this.$store.getters['conservatoryApplication/getData'];
            return isset(() => data.undergraduate_transfer.status) ? data.undergraduate_transfer.status : null
        },
        applicationStatusMessage() {
            if (this.application.status == 'waiting_program') {
                return this.$t('application_information_is_awaited');
            }
            else if (this.application.status == 'waiting_preference') {
                return this.$t('preference_information_is_awaited');
            }
            else if (this.application.status == 'waiting_documents') {
                return this.$t('required_documents_is_awaited');
            }
            else if (this.application.status == 'waiting_approve') {
                return this.$t('required_documents_approval_is_awaited');
            }
            else if (this.application.status == 'approved') {
                return this.$t('your_application_has_been_accepted');
            }
            else if (this.application.status == 'declined') {
                return this.$t('your_application_has_been_rejected');
            }
            else if (this.application.status == 'publish') {
                return this.$t('your_application_publish');
            }
            else if (this.application.status) {
                return this.$t('your_application_has_been_evaluated');
            }
            else {
                return '';
            }
        },

        resultStatusText(){
            let result = null
            if(this.application.result == 'waiting') {
                result = this.$t('waiting')
            } else if(this.application.result == 'placed') {
                result = this.$t('placed')
            } else {
                result = this.application.result
            }

            return result
        },
    },
    watch: {
        tabIndex: {
            handler(value){
                if(value === 4){
                    this.getExamListData()
                    this.getConstantKey()
                } else if(value == 2) {
                    this.showPaymentInfo()
                }
            }
        },
        'formData.program_code'(val){
            if (val){
                this.branchOptions=Branchs(val)
            }
        },
        'formData.second_program_code'(val){
            if (val){
                this.secondBranchOptions=Branchs(val)
            }
        }
    },
    data() {
        return {
            letterAndSpaceMask: {
                mask: 'UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU',
                tokens: {
                    'U': {
                        pattern: /[A-Za-z ÇĞİÖŞÜçğıöşü]/,
                        transform: function (v) {
                            v = v.replaceAll('i', 'İ');
                            return v.toUpper();
                        }
                    }
                }
            },
            // Tab
            tabIndex: -1,

            // Pin
            pin: null,

            // Data
            application: {},
            // Form
            formLoading: false,
            formData: {},

            schoolMajorTypeOptions: [
                { value: null, text: '' },
                { value: this.$t('high_school_major_type_1'), text: this.$t('high_school_major_type_1') },
                { value: this.$t('high_school_major_type_2'), text: this.$t('high_school_major_type_2') },
                { value: this.$t('high_school_major_type_3'), text: this.$t('high_school_major_type_3') },
                { value: this.$t('high_school_major_type_4'), text: this.$t('high_school_major_type_4') },
                { value: this.$t('high_school_major_type_6'), text: this.$t('high_school_major_type_6') },
            ],
            constantAddress:null,

            approveModalContent: null,
            approveMode: null,
            approveApp: false,
            approveMultimedia: false,
            progressValue: 0,
            progressTime: null,
            estimateFields: [
                {
                    key: 'message',
                    label: this.$t('message'),
                },
                {
                    key: 'date',
                    label: this.$t('date'),
                },
            ],
            approveMultimediaValidate: false,
            approveAppValidate: false,
            branchOptions: [],
            secondBranchOptions: [],
            footerInfo: null,
            generalTabInfo: null,
            disabilityOptions: [
                { value: 'H', text: this.$t('none') },
                { value: 'E', text: this.$t('available') }
            ],
            examListData: [],
            examListFields: [
                {
                    key: 'rank',
                    label: this.$t('preference'),
                },
                {
                    key: 'program',
                    label: this.$t('program'),
                },
                {
                    key: 'exam_type_name',
                    label: this.$t('exam_type'),
                },
                {
                    key: 'exam_location',
                    label: this.$t('exam_place'),
                },
                {
                    key: 'classroom',
                    label: this.$t('classroom'),
                },
                {
                    key: 'exam_date',
                    label: this.$t('exam_date'),
                },
                {
                    key: 'exam_hour',
                    label: this.$t('exam_hour'),
                },
            ],
            noDataInfo: null,
            programDataInfo: true,
            yesNoOptions: [
                { value: 'H', text: this.$t('no') },
                { value: 'E', text: this.$t('yes') }
            ],
            statementInfo: null,
            statement1: false,
            statement1Validate: false,
            paymentFormData: {},
            expiryMonthOptions: [
                { value: '01', text: '01' },
                { value: '02', text: '02' },
                { value: '03', text: '03' },
                { value: '04', text: '04' },
                { value: '05', text: '05' },
                { value: '06', text: '06' },
                { value: '07', text: '07' },
                { value: '08', text: '08' },
                { value: '09', text: '09' },
                { value: '10', text: '10' },
                { value: '11', text: '11' },
                { value: '12', text: '12' },
            ],
            paymentHtml: '',
            paymentStatus: false,

        }
    },

    created() {
        // Branch Options
        // this.branchOptions = Branchs(this.formData.program_code)
        this.getFooterInfo()
        this.getGeneralInfo()
        this.getNoDataInfo()
    },

    mounted() {
        this.$store.dispatch('conservatoryApplication/initData');
        this.$store.dispatch('conservatoryApplication/isLogin');
        let data = this.$store.getters['conservatoryApplication/getData'];

        if (data) {
            this.application = data
            this.application.city = this.application.city != 'null' ?  parseInt(this.application.city) : null
            this.application.contact_city = this.application.contact_city != 'null' ? parseInt(this.application.contact_city) : null
        }
        // Pin
        this.pin = this.$store.getters['conservatoryApplication/getPin'];
        this.tabIndex = this.$store.getters['conservatoryApplication/getTab'];

        if(data.is_previous_application == true){
            this.previousApplicationInfo()
        }

        this.formData = null
        this.setFormData()

        //this.goToTab();

        //Mernis
        let mernis = this.$store.getters['conservatoryApplication/getMernis']
        if (mernis == 1) {
            this.getMernisData()
        }
    },

    methods: {
        // Set Form Data
        setFormData() {
            this.formData = this.application
            if(this.formData.exam_date != null) {
                this.formData.exam_date = this.formData.exam_date.substr(0,16)
            }
            this.formData.disability = this.formData.disability == true ? 'E' :  this.formData.disability == null ?  null : 'H'
            this.formData.has_university_enrollment = this.formData.has_university_enrollment == true ? 'E' :  this.formData.has_university_enrollment == null ?  null : 'H'
            this.statement1 = this.formData.is_document_barcode_number_notification_approved
            this.approveApp = this.formData.is_application_conditions_text_approved
            this.approveMultimedia = this.formData.is_consent_text_approved
        },

        openApproveModal(mode){
            this.approveMode = mode
            mode == 'App' ? this.approveApp = false : this.approveMultimedia = false
            mode == 'App' ? this.getApprovaltInfo('conservatory_application.application_conditions_text') : this.getApprovaltInfo('conservatory_application.consent_text')
            this.$refs.approveAppModal.$refs.commonModal.show()
        },

        async approveAction(){
            let key = ''
            if(this.approveMode == 'App'){
                this.approveApp = true
                key = 'is_application_conditions_text_approved'
            } else {
                this.approveMultimedia = true
                key = 'is_consent_text_approved'
            }

            await this.approveConsent(key).then(() => {
                let formData = {
                    national_id: this.formData.national_id,
                    pin: this.pin,
                }
                ConservatoryService.login(formData).then(response => {
                    let data = response.data.data
                    if(data) {
                        // Data
                        if (data) {
                            this.$store.commit('fashionDesignApplication/setData', data)
                        }
                    }
                })
            })

            this.$refs.approveAppModal.$refs.commonModal.hide()
        },

        goToTab() {
            if (this.applicationStatus) {
                if (this.applicationStatus == 'waiting_program') {
                    this.tabIndex = 0;
                }
                else if (this.applicationStatus == 'waiting_preference') {
                    this.tabIndex = 1;
                }
                else if (this.applicationStatus == 'waiting_documents') {
                    this.tabIndex = 2;
                }
                else if (this.applicationStatus == 'waiting_approve') {
                    this.tabIndex = 3;
                }
            }
        },

        // Save
        async save() {
            const isValid = await this.$refs.personalInfoFormValidate.validate();
            if (isValid) {
                this.formData.mobile_tel = this.formData.mobile_tel.replace(/[^\d]/g, '')
                this.formData.alternative_mobile_tel = this.formData.alternative_mobile_tel ? this.formData.alternative_mobile_tel.replace(/[^\d]/g, '') : null

                let formData = new FormData()
                formData.append('pin', this.pin)
                formData.append('national_id', this.formData.national_id)
                formData.append('name', this.formData.name)
                formData.append('surname', this.formData.surname)
                formData.append('birthdate', this.formData.birthdate)
                formData.append('birthplace', this.formData.birthplace)
                formData.append('gender', this.formData.gender)
                formData.append('nationality_code', this.formData.nationality_code)
                formData.append('father_name', this.formData.father_name)
                formData.append('mother_name', this.formData.mother_name)
                formData.append('email', this.formData.email)
                formData.append('mobile_tel', this.formData.mobile_tel)
                this.formData.alternative_mobile_tel ? formData.append('alternative_mobile_tel', this.formData.alternative_mobile_tel) : false
                formData.append('city', this.formData.city)
                formData.append('district', this.formData.district)
                this.formData.address ? formData.append('address', this.formData.address) : false
                this.formData.postal_code ? formData.append('postal_code', this.formData.postal_code) : false
                formData.append('contact_city', this.formData.contact_city)
                formData.append('contact_district', this.formData.contact_district)
                this.formData.contact_address ? formData.append('contact_address', this.formData.contact_address) : false
                this.formData.contact_postal_code ? formData.append('contact_postal_code', this.formData.contact_postal_code) : false
                formData.append('disability', this.formData.disability == 'E' ? 1 : 0)
                this.formData.disability_file ? formData.append('disability_file', this.formData.disability_file) : false

                this.formLoading = true
                ConservatoryService.updatePersonalInfo(formData).then(response => {
                    let data = response.data.data
                    this.application = data
                    this.application.city = this.application.city != 'null' ?  parseInt(this.application.city) : null
                    this.application.contact_city = this.application.contact_city != 'null' ? parseInt(this.application.contact_city) : null
                    this.setFormData();
                    this.$store.commit('conservatoryApplication/setData', data)
                    this.$store.commit('conservatoryApplication/clearMernis')

                    this.$toast.success(this.$t('successfully_saved'));
                    this.goTab(1)
                }).catch(e => {
                    this.showErrors(e, this.$refs.personalInfoFormValidate);
                }).finally(() => {
                    this.formLoading = false
                })

            }
        },

        // Save Education Info
        async saveEducationInfo() {
            let statement = this.formData.has_university_enrollment == 'E' ? true :(this.formData.has_university_enrollment == 'H' && this.statement1)
            const isValid = await this.$refs.educationInfoFormValidate.validate();
            if (isValid && statement) {
                let formData = {
                    national_id: this.formData.national_id,
                    pin: this.pin,
                    school_name: this.formData.school_name,
                    school_code: this.formData.school_code,
                    school_diploma_point: this.formData.school_diploma_point,
                    school_graduate_date: this.formData.school_graduate_date,
                    school_major_type: this.formData.school_major_type,
                    exam_year: this.formData.exam_year,
                    exam_point: this.formData.exam_point,
                    has_university_enrollment: this.formData.has_university_enrollment == 'E' ? 1 : 0,
                    university_barcode_no: this.formData.university_barcode_no,
                }

                this.formLoading = true
                ConservatoryService.updateEducationInfo(formData).then(response => {
                    let data = response.data.data;
                    this.application = data
                    this.setFormData();
                    this.$store.commit('conservatoryApplication/setData', data)

                    this.$toast.success(this.$t('successfully_saved'));
                    this.goTab(2)
                }).catch(e => {
                    this.showErrors(e, this.$refs.educationInfoFormValidate);
                }).finally(() => {
                    this.formLoading = false
                })

            } else {
                if(this.statement1 == false) {
                    this.statement1Validate = true
                }
            }
        },

        async saveApplicationInfo(){
            const isValid = await this.$refs.applicationInfoFormValidate.validate();
            if (isValid && this.approveApp && this.approveMultimedia) {
                this.formLoading = true

                let formData = new FormData()
                formData.append('national_id',this.formData.national_id)
                formData.append('pin',this.pin)
                formData.append('program_code',this.formData.program_code)
                formData.append('interview_type',this.formData.interview_type)
                formData.append('letter_of_intent',this.formData.letter_of_intent)
                this.formData.second_program_code ? formData.append('second_program_code',this.formData.second_program_code) : false
                this.formData.second_interview_type ? formData.append('second_interview_type',this.formData.second_interview_type) : false
                this.formData.second_letter_of_intent ? formData.append('second_letter_of_intent',this.formData.second_letter_of_intent) : false
                if(this.formData.file){
                    this.showProgress(this.formData.file.size)
                    formData.append('file',this.formData.file)
                }
                if(this.formData.second_file && this.formData.second_program_code){
                    this.showProgress(this.formData.second_file.size)
                    formData.append('second_file',this.formData.second_file)
                }
                if(['11022101','11042101'].includes(this.formData.program_code)){
                    formData.append('program_detail',this.formData.program_detail.toString())
                } else {
                    formData.append('program_detail','')
                }
                if(['11022101','11042101'].includes(this.formData.second_program_code)){
                    formData.append('second_program_detail',this.formData.second_program_detail.toString())
                } else {
                    formData.append('second_program_detail','')
                }
                formData.append('link_1', this.formData.link_1)
                formData.append('link_2', this.formData.link_2)
                formData.append('is_previous_application_confirmed', this.formData.is_previous_application_confirmed ? 1 : 0)

                ConservatoryService.updateApplicationInfo(formData).then(response => {
                    let data = response.data.data;
                    this.application = data
                    this.application.city = this.application.city != 'null' ?  parseInt(this.application.city) : null
                    this.application.contact_city = this.application.contact_city != 'null' ? parseInt(this.application.contact_city) : null
                    this.setFormData();
                    this.$store.commit('conservatoryApplication/setData', data)

                    this.$toast.success(this.$t('successfully_saved'));
                    this.goTab(3)
                    this.approveMultimediaValidate = false
                    this.approveAppValidate = false

                    this.$swal.fire({
                        title: this.$t('application_successfully_sent'),
                        text: ' ',
                        showCancelButton: false,
                        confirmButtonText: this.$t('ok'),
                    })
                }).catch(e => {
                    this.showErrors(e, this.$refs.applicationInfoFormValidate);
                }).finally(() => {
                    this.formLoading = false
                })
            } else {
                if(this.approveMultimedia == false) {
                    this.approveMultimediaValidate = true
                }
                if(this.approveApp == false) {
                    this.approveAppValidate = true
                }

            }
        },

        async updateApplicationInfo(){
            const isValid = await this.$refs.applicationInfoFormValidate.validate()
            if (isValid && this.approveApp && this.approveMultimedia) {
                this.formLoading = true

                let formData = new FormData()
                formData.append('national_id',this.formData.national_id)
                formData.append('pin',this.pin)
                formData.append('program_code',this.formData.program_code)
                formData.append('interview_type',this.formData.interview_type)
                formData.append('letter_of_intent',this.formData.letter_of_intent)
                this.formData.second_program_code ? formData.append('second_program_code',this.formData.second_program_code) : false
                this.formData.second_interview_type? formData.append('second_interview_type',this.formData.second_interview_type) : false
                this.formData.second_letter_of_intent ? formData.append('second_letter_of_intent',this.formData.second_letter_of_intent) : false
                if(this.formData.file){
                    this.showProgress(this.formData.file.size)
                    formData.append('file',this.formData.file)
                }
                if(this.formData.second_file && this.formData.second_program_code){
                    this.showProgress(this.formData.second_file.size)
                    formData.append('second_file',this.formData.second_file)
                }
                if(['11022101','11042101'].includes(this.formData.program_code)){
                    formData.append('program_detail',this.formData.program_detail.toString())
                } else {
                    formData.append('program_detail','')
                }
                if(['11022101','11042101'].includes(this.formData.second_program_code)){
                    formData.append('second_program_detail',this.formData.second_program_detail.toString())
                } else {
                    formData.append('second_program_detail','')
                }

                ConservatoryService.updateApplicationInfo(formData).then(response => {
                    let data = response.data.data;
                    this.application = data
                    this.application.city = this.application.city != 'null' ?  parseInt(this.application.city) : null
                    this.application.contact_city = this.application.contact_city != 'null' ? parseInt(this.application.contact_city) : null
                    this.setFormData();
                    this.$store.commit('conservatoryApplication/setData', data)

                    this.$toast.success(this.$t('successfully_saved'));
                    this.goTab(3)
                    this.approveMultimediaValidate = false
                    this.approveAppValidate = false

                    this.$swal.fire({
                        title: this.$t('application_update_success'),
                        text: ' ',
                        showCancelButton: false,
                        confirmButtonText: this.$t('ok'),
                    })
                }).catch(e => {
                    this.showErrors(e, this.$refs.applicationInfoFormValidate);
                }).finally(() => {
                    this.formLoading = false
                })
            } else {
                if(this.approveMultimedia == false) {
                    this.approveMultimediaValidate = true
                }
                if(this.approveApp == false) {
                    this.approveAppValidate = true
                }

            }
        },

        showProgress(filesize){
            let uploadSpeed = 3000000 //bayt/s
            let maxValueInSeconds = Math.ceil(filesize/uploadSpeed)
            let onePercentPerSeconds = (maxValueInSeconds/100)*1000

            this.$refs.progressModal.$refs.commonModal.show()
            setInterval(() => {
                if(this.progressValue < 100){
                    this.progressValue += 1
                }
                if(this.formLoading == false){
                    this.$refs.progressModal.$refs.commonModal.hide()
                }

            }, onePercentPerSeconds)
        },

        downloadAppFile(type){
            let formData = {
                national_id: this.formData.national_id,
                pin: this.pin,
                type: type
            }
            ConservatoryService.downloadFileApplicationSide(formData).then(response => {
                this._downloadFile(response, response.headers.file_name)
            }).catch(e => {
                this.showErrors(e, null, true)
            })
        },

        getFooterInfo() {
            const config = {
                params: {
                    'key': 'conservatory_application.warning_message'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.footerInfo = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        getGeneralInfo() {
            const config = {
                params: {
                    'key': 'conservatory_application.information_text_tr'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.generalTabInfo = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        getApprovaltInfo(key) {
            const config = {
                params: {
                    'key': key
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.approveModalContent = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        getExamListData(){
            let formData = {
                national_id: this.formData.national_id,
                pin: this.pin
            }
            ConservatoryService.getExamList(formData).then(response => {
                this.examListData = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        getNoDataInfo() {
            const config = {
                params: {
                    'key': 'conservatory_application_status_warning_message'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.noDataInfo = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },
        getConstantKey(){
            const config = {
                params: {
                    key: 'conservatory_application.adress'
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            ConstantService.getValue(config)
                .then(response=>{
                    this.constantAddress=response.data.data
                }).catch(err=>{
                this.showErrors(err)
            })
        },

        checkProgramCode(event){
            this.formData.second_program_detail = ''
            if(['11012101','11032101'].includes(this.formData.program_code) && this.formData.program_code == event){
                this.programDataInfo = false
                this.$swal({
                    title: this.$t('attention'),
                    text: 'Aynı program ikinci kez seçilemez !',
                    showCancelButton: false,
                    confirmButtonText: this.$t('ok'),
                }).then(response => {
                    if (response.isConfirmed == true) {
                        this.programDataInfo = true
                    }
                })
                this.formData.second_program_code = null
            }
        },

        deleteLoadedProgramDetail(){
            this.formData.program_detail = ''
        },

        goTab(nextTab){
            this.$store.commit('conservatoryApplication/setTab', nextTab)
            this.tabIndex = nextTab
        },

        openStatement1Modal() {
            this.getStatementInfo()
            this.$refs.statementModal1.$refs.commonModal.show()
        },

        getStatementInfo() {
            const config = {
                params: {
                    'key': 'fashion_design_application.document_barcode_number_notification'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.statementInfo = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        async checkStatement1() {
            await this.approveConsent('is_document_barcode_number_notification_approved').then(() => {
                this.statement1 = true
                this.$refs.statementModal1.$refs.commonModal.hide()
                let formData = {
                    national_id: this.formData.national_id,
                    pin: this.pin,
                }
                ConservatoryService.login(formData).then(response => {
                    let data = response.data.data
                    if(data) {
                        // Data
                        if (data) {
                            this.$store.commit('conservatoryApplication/setData', data)
                        }
                    }
                })
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        async makePayment(){
            const isValid = await this.$refs.paymentFormValidate.validate()
            if (isValid) {
                this.$refs.paymentModal.$refs.commonModal.show()
                this.paymentFormData.card_number = this.paymentFormData.card_number.replaceAll(' ','')
                let formData = {
                    ...this.paymentFormData,
                    conservatory_application_id: this.formData.id
                }

                ConservatoryService.makePayment(formData).then(response => {
                    this.paymentHtml = response.data
                    this.paymentStatus = true
                }).catch(e => {
                    this.showErrors(e, this.$refs.paymentFormValidate)
                })

            }
        },

        async close3dModal(){
            this.$refs.paymentModal.$refs.commonModal.hide()
            if(this.paymentStatus) {
                let formData = {
                    national_id: this.formData.national_id,
                    pin: this.pin,
                }

                const request = await ConservatoryService.login(formData)
                let data = request.data.data
                if(data && data.payment_status == 'E') {
                    this.application.payment_status = data.payment_status
                    this.$swal.fire({
                        title: this.$t('application_successfully_sent'),
                        text: ' ',
                        icon:'success',
                        showCancelButton: false,
                        confirmButtonText: this.$t('ok'),
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.goTab(4)
                        }
                    })
                    // Data
                    if (data) {
                        this.$store.commit('conservatoryApplication/setData', data)
                    }
                    // National ID
                    if (this.loginForm.national_id) {
                        this.$store.commit('conservatoryApplication/setNationalID', data.national_id)
                    }
                    // Pin
                    if (this.loginForm.pin) {
                        this.$store.commit('conservatoryApplication/setPin', data.pin)
                    }
                    this.goTab(4)
                } else {
                    this.$swal.fire({
                        title: this.$t('unihall_unsuccess_pay'),
                        text: ' ',
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonText: this.$t('ok'),
                    })
                }

            }
        },

        getMernisData(){
            let formData = {
                national_id: this.formData.national_id,
                pin: this.pin
            }
            ConservatoryService.getMernis(formData).then(response => {
                let data = response.data.data
                this.formData.gender = data.gender
                this.formData.birthplace = data.birthplace
                this.formData.mother_name = data.mother_name
                this.formData.nationality_code = data.nationality_code
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        selectedSchool(data){
            if(data){
                this.formData.school_code = data.code
            }
        },

        async approveConsent(key){
            let formData = {
                national_id: this.formData.national_id,
                pin: this.pin,
                type: key
            }

            const data = await ConservatoryService.approveConsent(formData)
            return data
        },

        showPaymentInfo() {
            this.$swal.fire({
                text: this.$t('conservatory_payment_info'),
                showCancelButton: false,
                confirmButtonText: this.$t('ok'),
                icon: 'info'
            })
        },

        previousApplicationInfo() {
            this.$swal.fire({
                text: this.$t('conservatory_previous_app_info'),
                showCancelButton: false,
                confirmButtonText: this.$t('ok'),
                icon: 'warning'
            })
        }

    }
}
</script>
